module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/MA-0566c8d6785fbbfbd8cf482546412584.png";